import { Component } from '@angular/core';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';

import { first } from 'rxjs/operators';

import { Store } from '@ngrx/store';

import { AppleDevice, Device } from '@era/locations-sdk';

import { AppleDeviceStoreSelectors, DeviceStoreActions } from '@era/stores';

@Component({
  selector: 'era-device-unavailable',
  templateUrl: './device-unavailable.container.html',
  styleUrls: ['./device-unavailable.container.scss'],
  imports: [RouterLink],
})
export class DeviceUnavailableContainerComponent {
  constructor(
    private readonly router: Router,
    private readonly route: ActivatedRoute,
    private readonly deviceStore: Store<Device>,
    private readonly appleDeviceStore: Store<AppleDevice>
  ) {}

  public markAsUnavailable() {
    this.appleDeviceStore
      .select(AppleDeviceStoreSelectors.selectCurrentDeviceLink)
      .pipe(first())
      .subscribe((link) => {
        this.deviceStore.dispatch(DeviceStoreActions.DeviceUnassignViewActions.deviceUnavailable({ deviceLink: link }));
        void this.router.navigate(['../'], { relativeTo: this.route });
      });
  }
}
